import type { SyntheticEvent } from 'react';

// Nur eine Sprachprobe gleichzeitig abspielen: beim Start eines <audio>-Players
// alle anderen Player im selben <section>-Abschnitt pausieren.
export function pauseSiblingAudios(e: SyntheticEvent<HTMLAudioElement>) {
  const current = e.currentTarget;
  current.closest('section')?.querySelectorAll('audio').forEach((a) => { if (a !== current) a.pause(); });
}
